// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@awc/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsHeader";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { StyledTypography } from "@insite/mobius/Link";
import { css } from "styled-components";

headerStyles.buttonGridItem = {
    width: 12,
    css: css`
        display: flex;
        gap: 16px;
        justify-content: end;
    `,
};

headerStyles.titleGridItem = {
    width: 12,
};

headerStyles.headerGridContainer = {
    gap: 0,
};

headerStyles.title = {
    variant: "h1",
};

headerStyles.returnButton = {
    variant: "secondary",
    css: css`
        margin-bottom: 24px;
        ${xScreen("lte", "sm")} {
            display: none;
        }
        @media Print {
            display: none;
        }
    `,
};
headerStyles.orderApprovalDetailsActionButtonsStyles = {
    printButton: {
        variant: "primary",
        buttonType: "solid",
    },
};